import { CTASection } from '@/sections/CTASection';
import { HeaderSection } from '@/sections/HeaderSection';
import { HeroSection } from '@/sections/HeroSection';
import { PresentationSection } from '@/sections/PresentationSection';
import { VideoSection } from '@/sections/VideoSection';
import { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './styles.scss';

const SIGNUP_HASHES = new Set(['#signup', '#contact']);

export const MainPage = () => {
  const location = useLocation();
  const signupFormRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const scrollToSignupForm = useCallback(() => {
    const element = signupFormRef.current;
    if (!element) return;

    element.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => {
      inputRef.current?.focus();
    }, 200);
  }, []);

  useEffect(() => {
    const fromHash = SIGNUP_HASHES.has(location.hash);
    console.log(fromHash);
    if (fromHash) {
      scrollToSignupForm();
    }
  }, [location.hash, scrollToSignupForm]);

  return (
    <>
      <main className='main'>
        <HeaderSection onContactClick={scrollToSignupForm} />
        <HeroSection />
        <PresentationSection />
        <VideoSection />
        <CTASection
          signupFormRef={signupFormRef}
          inputRef={inputRef}
          onGetTheDeckClick={scrollToSignupForm}
        />
      </main>
    </>
  );
};
